/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

// Import jQuery and Slick Carousel from node_modules
import $ from 'jquery';
import 'slick-carousel';

// Ensure jQuery is available globally (required by Slick)
window.jQuery = window.$ = $;

document.addEventListener('DOMContentLoaded', () => {
    const productList = document.querySelector('.wp-block-showstopper-basic-carousel');
    
    // Initialize Slick Carousel
    $(productList).slick({
        slidesToShow: 1,      // Default: 1 item per view
        slidesToScroll: 1,    // Scroll one slide at a time
        infinite: true,       // Loop if more than 1 item
        variableWidth: false,
        centerMode: false,
        arrows: true,        // We'll add custom buttons
        dots: true,          // Show pagination dots
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    dots: false
                }
            }
        ]
    });

});
